import moment from 'moment';
import Form from './../../utils/forms/forms';
import newsStatusService from './../../services/newsStatus';
import newsTransformer from './../../transformers/news';

export default {
  data() {
    return {
      form: new Form({
        subject: {
          type: 'text',
          value: '',
        },
        sendAfterDate: {
          type: 'date',
          value: '',
        },
        sendAfterTime: {
          type: 'time',
          value: '',
        },
        sendAfter: {
          type: 'number',
          value: '',
        },
        htmlEmail: {
          type: 'switch',
          value: 0,
        },
        body: {
          type: 'editor',
          value: '',
        },
        newsCampaignId: {
          type: 'hidden',
          value: '',
        },
        campaignType: {
          type: 'hidden',
          value: '',
        },
        testEmail: {
          type: 'text',
          value: '',
        },
        testEmailCheck: {
          type: 'switch',
          value: 0,
        },
      }),
      testLoading: false,
      statuses: [],
    };
  },

  props: {
    create: {
      type: Function,
      required: true,
    },

    test: {
      type: Function,
      required: true,
    },

    campaign: {
      type: Object,
      required: true,
    },

    email: {
      type: Object,
      required: false,
    },

    listMessage: {
      type: String,
      required: false,
    }
  },

  watch: {
    /**
     * Watch default email.
     *
     * @param  {Boolean} value Checked or not.
     */
    'form.testEmailCheck': function (value) {
      if (value) {
        this.form.showField('testEmail');
      } else {
        this.form.hideField('testEmail');
      }
    },
    'form.htmlEmail': function (value) {
      if (value) {
        this.form.setField('body', 'textarea');
      } else {
        this.form.setField('body', 'editor');
      }
    },
  },

  methods: {
    createEmail(draft) {
      const data = this.form.data();
      const elem = document.querySelector('.ck.ck-content.ck-editor__editable.ck-rounded-corners.ck-blurred.ck-editor__editable_inline');
      data.sendAfterDate = data.sendAfterDate ?
      `${moment(data.sendAfterDate).format('YYYY-MM-DD')} ${data.sendAfterTime}` : '';

      const status = draft ? 'draft' : 'ready';
      data.newsStatusId = this.statuses.filter(s => s.name === status)[0].id;
      data.body = this.form.body;
      const news = newsTransformer.send(data);

      this.form.loading = status;
      this.create(news, this.email ? this.email.id : undefined)
      .then(() => {
        this.form.loading = false;
        const message = this.email ? this.$t('static.news.edit.updateSucess') : this.$t('static.news.create.createSucess');
        this.$message({
          showClose: true,
          message,
          type: 'success',
        });
        this.$emit('close');
      }).catch((e) => {
        this.form.loading = false;
        this.form.recordErrors(e);
      });
    },

    testEmail() {
      this.testLoading = true;
      const data = this.form.data();
      data.sendAfterDate = data.sendAfterDate ?
      `${moment(data.sendAfterDate).format('YYYY-MM-DD')} ${data.sendAfterTime}` : '';
      this.test(newsTransformer.send(data)).then(() => {
        this.testLoading = false;
        this.$message({
          showClose: true,
          message: this.$t('static.news.create.sendTestSucess'),
          type: 'success',
        });
      }).catch((e) => {
        this.testLoading = false;
        this.form.recordErrors(e);
      });
    },
  },

  mounted() {
    newsStatusService.all().then((r) => {
      this.statuses = r;
    });
    if (this.campaign.campaignType === 'Sequence') {
      this.form.hideField('sendAfterDate');
      this.form.hideField('sendAfterTime');
    } else {
      this.form.hideField('sendAfter');
    }
    this.form.setTooltip('body', this.$t('static.campaigns.edit.emailBodyTooltip'));
    if (this.email) {
      const data = Object.assign({}, this.email);
      if (moment(this.email.sendAfterDate).isValid()) {
        data.sendAfterTime = moment(this.email.sendAfterDate).format('HH:mm');
      } else {
        data.sendAfterDate = '';
        data.sendAfterTime = '';
      }
      if (data.htmlEmail) {
        this.form.setField('body', 'textarea');
      }
      this.form.assignData(data);
    }
    this.form.campaignType = this.campaign.campaignType;
    this.form.newsCampaignId = this.campaign.id;
    this.form.hideField('testEmail');
  },
  components: {
    VForm: require('./../form/form.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/components/addEmail/addEmail.js